<template>
    <component
        :is="'h' + size"
        class="tw-font-medium"
        :class="headingClasses"
    >
    {{ title }}
    </component>
</template>

<script>
export default {
    name: "Heading",

    props: {
        title: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            required: true,
        },
        hasPaddingBottom: {
            type: Boolean,
        }
    },

    computed: {
        headingClasses() {
            if (this.hasPaddingBottom) {
                return { 'tw-pb-3': true }
            }
            switch (this.size) {
                case 1:
                    return {
                        'tw-text-4xl': true,
                    };
                case 2:
                    return {
                        'tw-text-xl': true,
                        'tw-mb-4': true,
                        'tw-mt-12': true,
                        'md:tw-mt-8': true,
                    };
                case 3:
                    return {
                        'tw-text-l': true,
                        'tw-mt-12': true,
                        'tw-mb-2': true,
                    };
                case 4:
                    return {
                        'tw-text-md': true,
                    };
                case 5:
                    return {
                        'tw-text-sm': true,
                    };
            }
        }
    },
}
</script>

<style scoped>

</style>